"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var basic_table_component_1 = require("../../../basic-component/basic-table.component");
var addTablePy_1 = require("workbenchRoot/widgets/action/add-tables/app/js/logic/addTablePy");
var graphicsAdapters_1 = require("workbenchRoot/widgets/action/add-tables/app/js/logic/graphicsAdapters");
var UniversalChartComponent = /** @class */ (function () {
    function UniversalChartComponent($scope) {
        var _this = this;
        this.$onChanges = function () {
            var ctrl = this;
            if (ctrl.chartInputData !== undefined && ctrl.chartType !== undefined) {
                ctrl.origChartInputData = angular.copy(ctrl.chartInputData);
                ctrl.chartMatrix = new addTablePy_1.Matrix(ctrl.chartInputData).trimEmptyCols().trimEmptyRows();
                if (ctrl.chartType == "line" || ctrl.chartType == "bar") {
                    ctrl.transpose();
                    console.log(1);
                }
                if (ctrl.chartRotationIndex !== null && ctrl.chartRotationIndex !== undefined) {
                    if (ctrl.chartType == "bubble") {
                        ctrl.getRotatedChartInputDataForBubble();
                    }
                    else if (ctrl.chartType == "scatter") {
                        ctrl.getRotatedChartInputDataForScatter();
                    }
                }
                var adapter = new graphicsAdapters_1.HighCharts(ctrl.chartType, ctrl.chartName, ctrl.chartSettings);
                adapter.setup(ctrl.chartMatrix.data, ctrl.orientation);
                ctrl.adapter = adapter;
                ctrl.drawChart();
            }
        };
        this.changeLabelLength = function (change) {
            if (change === void 0) { change = 0; }
            var ctrl = _this;
            if (!ctrl.chartSettings.charsInLabel) {
                ctrl.chartSettings.charsInLabel = 0;
            }
            ctrl.chartSettings.charsInLabel = parseInt(ctrl.chartSettings.charsInLabel);
            ctrl.chartSettings.charsInLabel += change;
            var adapter = new graphicsAdapters_1.HighCharts(ctrl.chartType, ctrl.chartName, ctrl.chartSettings);
            ctrl.drawChart();
        };
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.matrixOrientation = "original";
        ctrl.counter = 0;
    }
    UniversalChartComponent.prototype.changeChart = function (chartType) {
        var ctrl = this;
        ctrl.counter = 0;
        ctrl.chartInputData = angular.copy(ctrl.origChartInputData);
        ctrl.chartType = chartType;
        var adapter = new graphicsAdapters_1.HighCharts(ctrl.chartType, ctrl.chartName, ctrl.chartSettings);
        ctrl.chartMatrix = new addTablePy_1.Matrix(ctrl.chartInputData).trimEmptyCols().trimEmptyRows();
        if (ctrl.chartType == "line" || ctrl.chartType == "bar") {
            ctrl.transpose();
        }
        adapter.setup(ctrl.chartMatrix.data, ctrl.orientation);
        ctrl.adapter = adapter;
        ctrl.drawChart();
    };
    ;
    UniversalChartComponent.prototype.toggleChartType = function () {
        var ctrl = this;
        ctrl.chartType = ctrl.chartType === 'bar' ? 'line' : 'bar';
        ctrl.drawChart();
    };
    ;
    UniversalChartComponent.prototype.rotate = function () {
        var ctrl = this;
        ctrl.orientation = ctrl.orientation === "horizontal" ? 'vertical' : 'horizontal';
        if (ctrl.chartType == "scatter") {
            ctrl.chartRotationIndex = ctrl.counter % 2;
            this.getRotatedChartInputDataForScatter();
            ctrl.adapter.setup(ctrl.chartMatrix.data, ctrl.orientation);
            ctrl.counter++;
        }
        else if (ctrl.chartType == "bubble") {
            ctrl.chartRotationIndex = ctrl.counter % 6;
            this.getRotatedChartInputDataForBubble();
            ctrl.adapter.setup(ctrl.chartMatrix.data, ctrl.orientation);
            ctrl.counter++;
        }
        ctrl.drawChart();
    };
    ;
    UniversalChartComponent.prototype.getRotatedChartInputDataForBubble = function () {
        var ctrl = this;
        var permutation = [
            [1, 3, 2],
            [2, 1, 3],
            [2, 3, 1],
            [3, 1, 2],
            [3, 2, 1],
            [1, 2, 3]
        ];
        ctrl.chartInputData = angular.copy([
            ctrl.origChartInputData[0],
            ctrl.origChartInputData[permutation[ctrl.chartRotationIndex][0]],
            ctrl.origChartInputData[permutation[ctrl.chartRotationIndex][1]],
            ctrl.origChartInputData[permutation[ctrl.chartRotationIndex][2]]
        ]);
        ctrl.chartMatrix = new addTablePy_1.Matrix(ctrl.chartInputData).trimEmptyCols().trimEmptyRows();
    };
    UniversalChartComponent.prototype.getRotatedChartInputDataForScatter = function () {
        var ctrl = this;
        var permutation = [
            [2, 1],
            [1, 2]
        ];
        ctrl.chartInputData = angular.copy([
            ctrl.origChartInputData[0],
            ctrl.origChartInputData[permutation[ctrl.chartRotationIndex][0]],
            ctrl.origChartInputData[permutation[ctrl.chartRotationIndex][1]],
        ]);
        ctrl.chartMatrix = new addTablePy_1.Matrix(ctrl.chartInputData).trimEmptyCols().trimEmptyRows();
    };
    UniversalChartComponent.prototype.transpose = function () {
        var ctrl = this;
        ctrl.chartMatrix = ctrl.chartMatrix.transpose();
        ctrl.matrixOrientation = ctrl.matrixOrientation === "original" ? 'transposed' : 'original';
        ctrl.chartInputData = ctrl.chartMatrix.data;
    };
    ;
    UniversalChartComponent.prototype.drawChart = function () {
        var ctrl = this;
        ctrl.adapter.setType(ctrl.chartType, ctrl.orientation);
        ctrl.adapter.drawOn("chartContainer", ctrl.chartType);
    };
    ;
    UniversalChartComponent = __decorate([
        basic_table_component_1.Component({
            bindings: {
                chartInputData: '<',
                chartName: '<',
                chartType: '=',
                orientation: '=',
                chartRotationIndex: '=',
                chartSettings: '='
            },
            template: require('./universal-chart.component.html')
        }),
        __metadata("design:paramtypes", [Object])
    ], UniversalChartComponent);
    return UniversalChartComponent;
}());
angular.module('smartorg.r6.acts.universal.universalChart', []).component('universalChart', UniversalChartComponent);
module.exports = 'smartorg.r6.acts.universal.universalChart';
//# sourceMappingURL=universal-chart.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/universal-chart/universal-chart.component.js